import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { errorRoute} from './layouts';

const LAYOUT_ROUTES = [...errorRoute];

@NgModule({
    imports: [
        RouterModule.forChild(
            [
                ...LAYOUT_ROUTES
            ]
        )
    ],
    exports: [RouterModule]
})
export class ScreensDemoAppRoutingModule {}
